import { cn } from '../../../lib/styles';
import type { PressableProps, PressableType } from './types';

const ROUNDED_MAP: Record<PressableType, string> = {
  card: 'rounded-xl',
  default: 'rounded-sm',
  flush: 'rounded-none',
};

export function Pressable({
  children,
  onClick,
  type = 'default',
  fullWidth = false,
  fullHeight = false,
  disabled = false,
  ariaExpanded,
  ariaControls,
  ariaLabel,
}: PressableProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      aria-label={ariaLabel}
      className={cn(
        ROUNDED_MAP[type],
        fullWidth && 'w-full',
        fullHeight && 'flex h-full',
        'appearance-none border-none bg-none transition focus:outline-hidden focus-visible:ring-2 focus-visible:ring-spark-purple focus-visible:ring-offset-2 enabled:hover:bg-gray-100 disabled:cursor-not-allowed',
      )}
    >
      {children}
    </button>
  );
}
